// components/common/EntriesSelector.tsx
import React, { useState, useRef, useEffect } from "react";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

interface EntriesSelectorProps {
  value: number;
  options?: number[];
  onChange: (value: number) => void;
}

const EntriesSelector: React.FC<EntriesSelectorProps> = ({
  value,
  options = [10, 20, 50, 100],
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
 
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex items-center gap-2 text-sm" ref={wrapperRef}>
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-1.5 border border-slate-200 bg-white rounded-md px-3 py-1 cursor-pointer text-xs text-[#212121] select-none h-8 shadow-sm hover:bg-slate-50 transition duration-150"
        >
          {value}
          {isOpen ? (
            <IconChevronUp strokeWidth={1.5} size={16} />
          ) : (
            <IconChevronDown strokeWidth={1.5} size={16} />
          )}
        </button>

        {isOpen && (
          <div className="absolute left-0 mt-1 w-full bg-white border rounded shadow-lg z-50">
            {options.map((opt) => (
              <div
                key={opt}
                className={`px-3 py-2 cursor-pointer hover:bg-[#FBD037]/10  ${
                  opt === value ? "bg-[#FBD037] font-medium" : ""
                }`}
                onClick={() => {
                  onChange(opt);
                  setIsOpen(false);
                }}
              >
                {opt}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EntriesSelector;
